import { useState, useEffect, useRef } from 'react';
import { Typography } from '@mui/material';

const PRIMARY = '#8c7c0c';

const MESSAGES = [
    {
        title: 'Investing Made Simple & Transparent',
        message:
            'Start building your financial future today. Explore real estate opportunities worldwide and grow your wealth effortlessly.',
    },
    {
        title: 'Smart & Hassle-Free Tenant Management',
        message:
            'Say goodbye to manual record-keeping! Track rent payments, list properties with ease, and manage tenants seamlessly — all in one place.',
    },
    {
        title: 'Instant & Reliable Tenant Credit Access',
        message:
            'Struggling with rent this month? Get fast and secure credit access to cover your rent without hassle. Stay worry-free and keep your home stress-free!',
    },
];

const RotatingMessages = () => {
    const [index, setIndex] = useState(0);
    const [fading, setFading] = useState(false);
    const timerRef = useRef<ReturnType<typeof setInterval> | null>(null);

    useEffect(() => {
        timerRef.current = setInterval(() => {
            setFading(true);
            setTimeout(() => {
                setIndex((prev) => (prev + 1) % MESSAGES.length);
                setFading(false);
            }, 400);
        }, 7000);
        return () => { if (timerRef.current) clearInterval(timerRef.current); };
    }, []);

    const style: React.CSSProperties = {
        transition: 'opacity 0.4s ease, transform 0.4s ease',
        opacity: fading ? 0 : 1,
        transform: fading ? 'translateX(24px)' : 'translateX(0)',
    };

    const { title, message } = MESSAGES[index];

    return (
        <div style={{ overflow: 'hidden', width: '100%' }}>
            <div style={style}>
                <Typography
                    variant="h1"
                    sx={{ fontWeight: 'bold', mb: 3, fontSize: { xs: 36, sm: 56 }, lineHeight: 1.2 }}
                >
                    {title.split(' ').map((word, i) =>
                        i === 2 || i === 4 ? (
                            <span key={i} style={{ color: PRIMARY }}>{word} </span>
                        ) : (
                            word + ' '
                        )
                    )}
                </Typography>
                <Typography sx={{ fontSize: { xs: 16, sm: 20 }, color: '#6b7280', lineHeight: 1.7, mb: 4 }}>
                    {message}
                </Typography>
            </div>
        </div>
    );
};

export default RotatingMessages;
